module.exports = __webpack_public_path__ + "static/media/01A.18a06d73.png";